import { lazy } from 'react';

export const NoAccessCoverAsync = lazy(() => import('./NoAccessCover'));
